import { createContext, useContext } from 'react'

export const PageContext = createContext({})

export const PageContextProvider = ({ pageContext, children }) => (
  <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>
)

export const usePageContext = () => useContext(PageContext)
